export default "/_next/static/images/img3-1f5ba1bffe39640da0fd7820228678ee.png";